
<div class="columns" id="mail-app">
    <aside class="column is-2 aside hero is-fullheight" *ngIf="!isMobile || (isMobile && status == -2)">
        <div>
            <div class="main">
                <a class="item" href="/"><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Запросы</span></a>
                <a class="item" href="/users"><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Юзеры</span></a>
                <a class="item active" (click)="loadGpts(-1, 1);currentGpts = null;gpts=[];" ><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Настройки</span></a>
                <a class="item" href="/translations"><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Локализация</span></a>
<!--                <a class="item" href="/barcodes" ><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Штрихкоды</span></a>-->
                <a class="item" href="/barcodes-users" ><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Штрихкоды</span></a>
                <a class="item" href="/label-reviews"><span class="icon"><i class="fa fa-inbox"></i></span><span class="name">Label Reviews</span></a>
            </div>
        </div>
    </aside>
    <div class="column messages hero is-fullheight" id="message-feed" *ngIf="!currentGpts && (!isMobile || (isMobile && status > -2))">
        <div class="action-buttons">
            <div class="control is-grouped pg">
                <button class="button" *ngIf="isMobile" (click)="status = -2;">Вернуться назад</button>
                <div class="title">Список заявок (страница {{ page }} из {{ gptsData?.last_page }})</div>
                <a class="button " [class.is-link]="!isMobile" (click)="loadGpts(this.status, page-1)"><i class="fa fa-chevron-left"></i></a>
                <a class="button " [class.is-link]="!isMobile" (click)="loadGpts(this.status, page+1)"><i class="fa fa-chevron-right"></i></a>
            </div>
        </div>

        <div class="inbox-messages" id="inbox-messages">

            <div class="card clickable block" (click)="createVariant()">
                <div class="card-content">
                    <div class="msg-header">

                        <span class="msg-timestamp"></span>
                        <!--                        <span class="msg-attachment"><i class="fa fa-paperclip"></i></span>-->
                    </div>
                    <div class="msg-subject">
                        <span class="msg-subject"><strong >Нажмите что бы создать новый</strong></span>
                    </div>
                    <div class="msg-snippet">
                        <p ></p>
                    </div>
                </div>
            </div>


            <div *ngFor="let gpt of gpts" class="card clickable block" [style.opacity]="gpt.status ? 1 : 0.5" [class.active]="currentGpts?.gpts_variant_id == gpt.gpts_variant_id" >
                <div class="card-content">
                    <div class="msg-header">

                        <span class="msg-timestamp" (click)="selectGpt(gpt);$event.preventDefault();">{{ gpt.created_at | date:'dd.MM.YYYY HH:mm':'GMT+3' }}</span>
                        <span class="msg-attachment"><a (click)="deleteVariant(gpt);$event.preventDefault();">Удалить</a> </span>
                    </div>
                    <div class="msg-subject" (click)="selectGpt(gpt);$event.preventDefault();">
                        <span class="msg-subject"><strong id="fake-subject-1"><b style="color:red">v{{ gpt.version }}</b> {{ gpt.name }} <b style="color: green">{{ gpt.flags }}</b></strong></span>
                    </div>
                    <div class="msg-snippet" (click)="selectGpt(gpt);$event.preventDefault();">
                        <p id="fake-snippet-1">{{ gpt.string }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="column hero is-fullheight" [class.message]="!isMobile" *ngIf="currentGpts" id="message-pane">

        <div class=""  [class.box]="!isMobile">
            <div class="top">
                <div class="address">
                    <div class="name">
                        <div class="field is-grouped is-grouped-multiline" >
                            <p class="control">
                                <a class="button" (click)="currentGpts = null;loadGpts(-1, 1);currentGpts = null;gpts=[];">Вернуться назад</a>
                            </p>
                        </div>
                    </div>
                    <div class="name">
                        {{ currentGpts.gpts_variant_id }}
                    </div>

                </div>
                <hr>
                <div class="content">

                    <table class="table is-bordered">
                        <tr>
                            <td>Номер</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <input class="input" disabled type="text" [(ngModel)]="newGpt.gpts_variant_id">
                                    </div>
                                    <div class="control" *ngIf="currentGpts.gpts_variant_id != newGpt.gpts_variant_id" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Название</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <input class="input" [(ngModel)]="newGpt.name">
                                    </div>
                                    <div class="control" *ngIf="currentGpts.name != newGpt.name" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Запрос</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <textarea class="textarea" [(ngModel)]="newGpt.string"></textarea>
                                    </div>
                                    <div class="control" *ngIf="currentGpts.string != newGpt.string" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Тип</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" [value]="1" name="type" [(ngModel)]="newGpt.type">
                                            Локальное сообщение бота
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="0" name="type" [(ngModel)]="newGpt.type">
                                            Запрос в GPT-4
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="7" name="type" [(ngModel)]="newGpt.type">
                                            Запрос в GPT-4 после ошибки
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="2" name="type" [(ngModel)]="newGpt.type">
                                            Конец запроса в GPT-4
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="3" name="type" [(ngModel)]="newGpt.type">
                                            Сообщение что часть истории отсутствует
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="4" name="type" [(ngModel)]="newGpt.type">
                                            Первое сообщение бота в цепочке
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="5" name="type" [(ngModel)]="newGpt.type">
                                            Последнее сообщение бота в цепочке
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="6" name="type" [(ngModel)]="newGpt.type">
                                            GPT-4 Текст перед профилем
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="8" name="type" [(ngModel)]="newGpt.type">
                                            Текст после [FAILED OUTPUT] с ошибками
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="9" name="type" [(ngModel)]="newGpt.type">
                                            Детектор флагов
                                        </label>
                                    </div>

                                    <div class="control" *ngIf="currentGpts.type != newGpt.type" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Версия</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" [value]="3" name="version" [(ngModel)]="newGpt.version">
                                            v3
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="2" name="version" [(ngModel)]="newGpt.version">
                                            v2
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="0" name="version" [(ngModel)]="newGpt.version">
                                            v1
                                        </label>
                                    </div>

                                    <div class="control" *ngIf="currentGpts.version != newGpt.version" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Шаг</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" [value]="1" name="step" [(ngModel)]="newGpt.step">
                                            1
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="2" name="step" [(ngModel)]="newGpt.step">
                                            2
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="0" name="step" [(ngModel)]="newGpt.step">
                                            0 (не используется)
                                        </label>
                                    </div>

                                    <div class="control" *ngIf="currentGpts.step != newGpt.step" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>



                        <tr>
                            <td>Роль</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <label class="radio">
                                            <input type="radio" [value]="1" name="status" [(ngModel)]="newGpt.status">
                                            Главный
                                        </label>
                                        <label class="radio">
                                            <input type="radio" [value]="0" name="status" [(ngModel)]="newGpt.status">
                                            В архиве
                                        </label>
                                    </div>

                                    <div class="control" *ngIf="currentGpts.status != newGpt.status" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Флаги, при которых будет использовано (флаги должны быть отсортированы, пример ["ab","ac","bc"])</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <input class="input" type="text" [(ngModel)]="newGpt.flags">
                                    </div>
                                    <div class="control" *ngIf="currentGpts.flags != newGpt.flags" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr style="display: none;">
                            <td>Функция в коде</td>
                            <td>
                                <div class="field" >
                                    <div class="control">
                                        <input class="input" type="text" [(ngModel)]="newGpt.command">
                                    </div>
                                    <div class="control" *ngIf="currentGpts.command != newGpt.command" >
                                        <a class="button" (click)="updateData()">Сохранить</a>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Дата создания</td>
                            <td>{{ currentGpts.created_at | date:'dd.MM.YYYY HH:mm':'GMT+3' }}</td>
                        </tr>
                        <tr>
                            <td>Дата изменения</td>
                            <td>{{ currentGpts.updated_at | date:'dd.MM.YYYY HH:mm':'GMT+3' }}</td>
                        </tr>


                    </table>

                </div>
            </div>
        </div>
    </div>
</div>